import { combineReducers as reduxCombineReducers } from 'redux';

import { notificationsCentre } from 'modules/notificationsCentre/store/reducer';
import { auth } from './login/loginReducer';
import { instrument } from './instrument/instrumentReducer';
import { entity } from './entity/entityReducer';
import { notifications } from './notifications/notificationsReducer';
import { recentUsers } from './recentUsers/recentUsersReducer';
import { searchResult } from './searchResult/searchResultReducer';
import { announcement } from './announcement/announcementReducer';
import { newsFeed } from './newsFeed/newsFeedReducer';
import { dossier } from './portfolio/dossierReducer';
import { shared } from './shared/sharedReducer';
import { investor } from './investor/investorReducer';
import { creditReview } from './creditReview/creditReviewReducer';
import { shop } from '../modules/shop/store/shopReducer';
import { events } from '../modules/events/store/eventsReducer';
import { esgContract } from './esg/esgReducer';
import { esgCoverage } from './esgCoverage/esgCoverageReducer';

export const combineReducers = reduxCombineReducers({
  auth,
  instrument,
  entity,
  notifications,
  recentUsers,
  searchResult,
  announcement,
  newsFeed,
  dossier,
  shared,
  investor,
  creditReview,
  shop,
  notificationsCentre,
  events,
  esgContract,
  esgCoverage,
});
